<template>
  <div class="page">
    <div class="public-wrap">
      <brand-logo size="xl" />
      <p class="domain">ridelilo.com</p>
      <p class="lead"><brand-product kind="ride" /> and <brand-product kind="school" /> from Lilo PLC, Addis Ababa.</p>
    </div>
  </div>
</template>
<script>
import BrandLogo from '@/components/BrandLogo.vue'
import BrandProduct from '@/components/BrandProduct.vue'
export default { components: { BrandLogo, BrandProduct } }
</script>
<style scoped>
.page { padding: 64px 0 96px; text-align: center; }
.public-wrap { width: min(560px, calc(100% - 32px)); margin: 0 auto; }
.domain { color: #FFA800; font-weight: 600; margin: 16px 0 12px; }
.lead { font-size: 1.15rem; color: #6B7280; margin: 0; }
</style>
